module["exports"] = [
  "Ава",
  "Александра",
  "Ана",
  "Анастасија",
  "Анѓа",
  "Ангела",
  "Ангелина",
  "Анче",
  "Атанасија",
  "Билјана",
  "Бисера",
  "Бистра",
  "Блага",
  "Благица",
  "Благојка",
  "Благородна",
  "Благуна",
  "Блаженка",
  "Богдана",
  "Богиња",
  "Божана",
  "Бојана",
  "Борјана",
  "Борка",
  "Босилка",
  "Бранка",
  "Валентина",
  "Вања",
  "Варвара",
  "Василка",
  "Василија",
  "Васка",
  "Велика",
  "Вера",
  "Вероника",
  "Весела",
  "Весна",
  "Виолета",
  "Војданка",
  "Воскресија",
  "Габриела",
  "Галаба",
  "Галена",
  "Голубинка",
  "Гордана",
  "Горица",
  "Горјана",
  "Грозда",
  "Дамјана",
  "Даница",
  "Данка",
  "Даринка",
  "Дафина",
  "Деница",
  "Десанка",
  "Деспина",
  "Дивна",
  "Добрила",
  "Добринка",
  "Домника",
  "Донка",
  "Драга",
  "Драгана",
  "Душанка",
  "Душка",
  "Ѓурѓа",
  "Ѓурѓица",
  "Ева",
  "Евгенија",
  "Евдокија",
  "Екатерина",
  "Елена",
  "Елеонора",
  "Елисавета",
  "Елица",
  "Елка",
  "Есма",
  "Ефимија",
  "Ефросина",
  "Живка",
  "Загорка",
  "Зафирка",
  "Захаринка",
  "Здравка",
  "Злата",
  "Зора",
  "Зорица",
  "Зорка",
  "Sвезда",
  "Ива",
  "Ивана",
  "Иванка",
  "Илинденка",
  "Илинка",
  "Ирина",
  "Искра",
  "Јаворка",
  "Јагода",
  "Јадранка",
  "Јана",
  "Јанка",
  "Јасна",
  "Јована",
  "Јовка",
  "Јордана",
  "Јорданка",
  "Јулијана",
  "Калина",
  "Каранфилка",
  "Ката",
  "Катерина",
  "Катина",
  "Катица",
  "Катја",
  "Кераца",
  "Кита",
  "Климентина",
  "Константина",
  "Косара",
  "Костадинка",
  "Крстана",
  "Лена",
  "Ленче",
  "Лепа",
  "Лидија",
  "Лика",
  "Лилјана",
  "Лина",
  "Љуба",
  "Љубинка",
  "Љубица",
  "Љупка",
  "Магдалена",
  "Македонка",
  "Макрина",
  "Мара",
  "Марија",
  "Марика",
  "Марина",
  "Марта",
  "Матрона",
  "Меглена",
  "Меланија",
  "Мена",
  "Мери",
  "Милева",
  "Милена",
  "Милица",
  "Милка",
  "Мирјана",
  "Мирка",
  "Нада",
  "Надежда",
  "Наумка",
  "Невенка",
  "Неда",
  "Неделка",
  "Никодина",
  "Николина",
  "Олга",
  "Оливера",
  "Павлина",
  "Павлинка",
  "Параскева",
  "Пауна",
  "Пелагија",
  "Петкана",
  "Петра",
  "Петранка",
  "Писана",
  "Радмила",
  "Рајна",
  "Ракита",
  "Рафаила",
  "Рахела",
  "Рахилка",
  "Ристана",
  "Родна",
  "Роса",
  "Роска",
  "Ружа",
  "Румена",
  "Русалина",
  "Русанка",
  "Сава",
  "Сандра",
  "Сара",
  "Сашка",
  "Светлана",
  "Серафима",
  "Симјанка",
  "Симона",
  "Славенка",
  "Славица",
  "Славјанка",
  "Славка",
  "Слободанка",
  "Снежана",
  "Сончица",
  "Софија",
  "Спаса",
  "Спасена",
  "Споменка",
  "Сребра",
  "Стамена",
  "Стефанија",
  "Стефанка",
  "Стојанка",
  "Стојна",
  "Стојмена",
  "Сузана",
  "Тамара",
  "Таска",
  "Татјана",
  "Темјана",
  "Теодора",
  "Теодосија",
  "Теофилка",
  "Тодорка",
  "Трајанка",
  "Трена",
  "Трендафилка",
  "Убавка",
  "Фана",
  "Фанка",
  "Филимена",
  "Флоринка",
  "Фросина",
  "Христина",
  "Цара",
  "Цвета",
  "Цветанка"
];
